import React from 'react';
import {Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import {ButtonValidation, ButtonCancel} from '../../../../component/Button.js'
import moment from 'moment';
import {UpdatePropsReschedule} from '../../request.props.js';
import {PresenterUpdateReschedule} from '../../../presenter.js'
// Date airbnb
import 'react-dates/initialize'; // <---- put this at the very top of your js file fix issues: https://github.com/airbnb/react-dates/issues/750

import { DateRangePicker  } from 'react-dates';

import toUTCtime from '../../../../helper/UTCtime.js';
import { toast } from 'react-toastify';

// DEVELOPMENT
import axios from 'axios';
import ServerProperties from '../../../../config/server.js'
// END DEVELOPMENT

export default class ModalRescheduleDate extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      SelectedItemReschedule : null,
      startDate              : null,
      endDate                : null,
      date                   : null,
      focused                : null,
      focusedInput           : null,
      loading                : false,
      is_process             : false,
    }

    this.onDatesChange      = this.onDatesChange.bind(this);
    this.onFocusChange      = this.onFocusChange.bind(this);
    this.isDayBlocked       = this.isDayBlocked.bind(this);
    this.renderCalendarInfo = this.renderCalendarInfo.bind(this);

    this.updateReschedule = this.updateReschedule.bind(this)
    this.onUpdateSuccess = this.onUpdateSuccess.bind(this)
    this.onUpdateFailed = this.onUpdateFailed.bind(this)
  }

  onFocusChange({ focused }) {
    this.setState({ focused });
  }

  onDatesChange(startDate, endDate) {
     this.setState({ 
      startDate: startDate,
      endDate:endDate
    });
   }

  updateReschedule() {
    if(this.state.startDate != null && this.state.endDate != null) {

      let tmpStartDate = this.state.startDate;
      let tmpEndDate   = this.state.endDate;

      tmpStartDate._d.setHours(9);
      tmpStartDate._d.setMinutes(0);
      tmpStartDate._d.setSeconds(0);

      tmpEndDate._d.setHours(8);
      tmpEndDate._d.setMinutes(59);
      tmpEndDate._d.setSeconds(59);

      this.requestParams = {
        startDate_UTC : toUTCtime(tmpStartDate._d),
        endDate_UTC   : toUTCtime(tmpEndDate._d),
      }

      this.setState({is_process: true})

      PresenterUpdateReschedule(
        UpdatePropsReschedule(this, this.onUpdateSuccess, this.onUpdateFailed)
      )
    }
  }

  onUpdateSuccess(params, response) {
    this.setState({is_process: false})
    toast.success("Reschedule Success");
    params.self.props.self.closeModalRescheduleDate();    
    params.self.props.self.updateRowDate(response.data);
  }

  onUpdateFailed(params, response) {
    this.setState({is_process: false})
    try {
      toast.error(response);
    }
    catch(error) {
      console.error(response);
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.self.state.SelectedItemReschedule !== undefined && nextProps.self.state.modal.RescheduleDate){
      this.blockedList = []
      axios.defaults.headers.common['Authorization'] = "Bearer " + nextProps.self.props.UserReducer.token;
      axios.get(
        ServerProperties.ATM_CLOUD.API + 'Booking/Reservation/' + nextProps.self.state.SelectedItemReschedule.Asset.Alias + '/'
      )
      .then(
        response => {
          this.blockedList = response.data.map(
            val => {
              return {
                alias   : val.Alias,
                date    : moment.range(
                            moment(val.StartDate).hour(0),
                            moment(val.FinishDate).subtract(1, 'days').hour(23).minute(59).second(59)
                )  
              }
            }
          )
          this.setState({
            SelectedItemReschedule : nextProps.self.state.SelectedItemReschedule,
            startDate              : moment(nextProps.self.state.SelectedItemReschedule.StartDate),
            endDate                : moment(nextProps.self.state.SelectedItemReschedule.FinishDate),
            loading                : true,
          })
        }
      )
      .catch(
        error => {
          console.log('Request Error')
          // console.log(this)
        }
      );
      this.setState({
        loading: false
      })
    }
  }

  isDayBlocked = (day) => {
    for (let index in this.blockedList){

      let alias = this.blockedList[index]['alias']
      let book = this.blockedList[index]['date']
      
      if (alias !== this.state.SelectedItemReschedule.Alias) {
        if (book.contains(day)){
          return true
        } 
      }
    }
    return false
  }

  renderCalendarInfo() {
    return(
      <div className="date-info">
        <small>
          <div><span>Max :</span>&nbsp;<span>{this.state.SelectedItemReschedule.Asset.MaxDays} Day</span></div>
        </small>
      </div>
    )
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (nextProps.self.state.SelectedItemReschedule !== undefined){
      return true
    }
    return false
  }


  render() {
    const {is_process} = this.state

    if(this.state.SelectedItemReschedule == null) {
      return(null)
    }

    return (
      <Modal isOpen={this.props.self.state.modal.RescheduleDate} toggle={()=>this.props.self.closeModalRescheduleDate()} className ={this.props.className}>
      <ModalHeader toggle ={()=>this.props.self.closeModalRescheduleDate()}>Reschedule Booking Date</ModalHeader>
        
        <ModalBody>
          <div className="row">
            <div className="form-group col-sm-6">
              <label htmlFor="asset">Asset / Tools</label>
              <input
                type      ="text"
                className ="form-control"
                id        ="asset"
                value     ={this.state.SelectedItemReschedule.Asset.Name}
                disabled
              />
            </div>
            <div className="form-group col-sm-6">
              <label>Reschedule Date</label>
              <DateRangePicker
                startDate        = {this.state.startDate}
                endDate          = {this.state.endDate}
                onDatesChange    = {({ startDate, endDate }) => this.setState({ startDate, endDate }) } 
                focusedInput     = {this.state.focusedInput}
                onFocusChange    = {focusedInput => this.setState({ focusedInput })}
                numberOfMonths   = {1}
                isDayBlocked     = {this.isDayBlocked}
                renderCalendarInfo={this.renderCalendarInfo}
                hideKeyboardShortcutsPanel
              />
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <ButtonCancel onClick={()=>this.props.self.closeModalRescheduleDate()}>Cancel</ButtonCancel>
          <ButtonValidation is_process={is_process} onClick={()=>this.updateReschedule()} disabled={this.state.disabled}>Reschedule</ButtonValidation>
        </ModalFooter>
      </Modal>
    );
  }
}


// WEBPACK FOOTER //
// ./src/App/home/helper/component/Modal/ModalRescheduleDate.js